module.exports = __webpack_public_path__ + "img/face-laugh-beam.bf753b28.svg";